import { IconType } from "react-icons";
import { RiLogoutBoxRLine } from "react-icons/ri";
import {
  MdOutlineAdminPanelSettings,
  MdOutlineAssignment,
  MdOutlineCalendarMonth,
  MdOutlineHome,
  MdFolderOpen,
  MdSupportAgent,
} from "react-icons/md";
import { FaTasks } from "react-icons/fa";
import { BiMessageAltDots } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { GrDocumentPerformance } from "react-icons/gr";
import { LuShare2 } from "react-icons/lu";

/**
 * Drawer icon registry — the backend `FetchMenuRow.icon` value is a
 * react-icons component name (e.g. "MdOutlineCalendarMonth"); look it up here.
 * Icons are imported explicitly — never dynamically from the react-icons
 * package — so tree-shaking keeps the bundle small.
 *
 * To offer a new icon: import it here and add one registry line; the backend
 * can then reference it by name without a frontend deploy.
 *
 * Render via direct object lookup (e.g. `DRAWER_ICONS[icon]`) inside a
 * module-level component — do NOT route the lookup through a helper function
 * called during render: React 19.2 rejects component values produced by
 * function calls in render ("Cannot create components during render").
 */
export const DRAWER_ICONS: Record<string, IconType> = {
  MdOutlineHome,
  MdOutlineCalendarMonth,
  MdOutlineAssignment,
  MdFolderOpen,
  BiMessageAltDots,
  FaTasks,
  GrDocumentPerformance,
  MdOutlineAdminPanelSettings,
  CgProfile,
  LuShare2,
  RiLogoutBoxRLine,
  MdSupportAgent,
};

/**
 * Legacy fallback: icons keyed by the menu item's NAME. Active while the
 * backend `icon` column is still empty (zero-downtime migration, option A);
 * once every menu row carries an icon value, this map can be removed.
 */
export const LEGACY_DRAWER_ICONS: Record<string, IconType> = {
  home: MdOutlineHome,
  planning: MdOutlineCalendarMonth,
  assessmentFramework: MdOutlineAssignment,
  contentLibrary: MdFolderOpen,
  messages: BiMessageAltDots,
  task: FaTasks,
  selfAssessment: GrDocumentPerformance,
  admin: MdOutlineAdminPanelSettings,
  userProfile: CgProfile,
  logOut: RiLogoutBoxRLine,
  support: MdSupportAgent,
};
